import React, { useState } from 'react';
import { Button } from 'components';
import { renderKr } from 'utils/renderingService';
import PropTypes from 'prop-types';
import { toggleProductBoxContent, getHtml, classList } from 'utils/componentsCommon';
import { ProductTypes } from 'utils/enums';

const SelectableProduct = ({ product, chooseProductFunc, chooseProductText, elementId, className, fixedTop, selected, priceSuffix,chosen, ...props }) => {
    const classNames = classList(fixedTop ? 'fixedTop' : '', className);
    const [chooseProductTextValue, setChooseProductTextValue] = useState(chooseProductText);
    const [productChosen, setProductChosen] = useState(false);
    console.log('product', product);
    return (
        <>
            <div id={ selected ? 'law-products-selected' : 'law-products' }>
                { product && (
                    <div id={ elementId } className={ classNames } { ...props }>
                        <>
                            <div>
                                <div className="title">
                                    <h5>{ product.name }</h5>
                                </div>
                                { product.price ? (
                                    <>
                                        <div className="price">
                                            <div>
                                                { product.type === ProductTypes.Product && (
                                                    <>
                                                        { product.price.now && renderKr(product.price.now, '', 1) }
                                                        { !Number.isInteger(product.price.now) && product.price.standard && renderKr(product.price.standard, '', 1) }
                                                        <span>
                                                            kr. <span style={{ fontSize: '15px' }}> <span className="price-suffix">{ priceSuffix }</span></span>
                                                        </span>
                                                    </>
                                                ) }
                                                { product.type === ProductTypes.Subscription && (
                                                    <>
                                                        { product.price.yearly && renderKr(product.price.yearly / 12, '', 1) }
                                                        { product.price.monthly?.standard && renderKr(product.price.monthly?.standard, '', 1) }
                                                        <span>kr. / måned</span>
                                                    </>
                                                ) }

                                            </div>
                                            <p>

                                            </p>
                                        </div>
                                        <div>
                                            { product.highlight ?
                                                <strong className="highlight">
                                                    { product.highlight } { priceSuffix }
                                                </strong>:
                                                <strong className="highlight">
                                                    Uvildig juridisk rådgivning
                                                </strong>
                                            }



                                        </div>
                                        { product.descriptionTop &&
                                            <div>

                                                <div style={{ fontWeight: 'bold' }} dangerouslySetInnerHTML={ getHtml(product.descriptionTop) } />

                                            </div>
                                        }
                                    </>
                                ) : (
                                    <>
                                        <div dangerouslySetInnerHTML={ getHtml(product.descriptionShort) } />

                                    </>
                                ) }
                            </div>
                            { product.price ? (
                                <>
                                    { chosen && (
                                        <>

                                            <br />
                                            <Button color="white" disabled>
                                                Altid inkluderet
                                            </Button>
                                        </>
                                    ) }
                                    { chooseProductFunc && (
                                        <div className={ product.descriptionShort ? 'divider' : '' }>
                                            { product.descriptionShort &&
                                            <br />
                                            }
                                            <Button
                                                color="white"
                                                onClick={ () => {
                                                    chooseProductFunc();
                                                    setProductChosen(!productChosen);
                                                } }
                                            >
                                                { !productChosen ? chooseProductTextValue || product.cta || 'Vælg' : 'Fravælg' }
                                            </Button>
                                        </div>
                                    ) }
                                    {
                                        product.descriptionShort &&
                                        <div className="productInfoTitle">{ product.descriptionShort }</div>

                                    }

                                    <div>

                                        <div className="moreAnchor">
                                            <a onClick={ () => toggleProductBoxContent(elementId) }>+ Læs mere</a>
                                        </div>

                                        <div className="hidden description" dangerouslySetInnerHTML={ getHtml(product.description) } />
                                        { product.valueDescription && (
                                            <>
                                                <br />
                                                <div className="hidden description" dangerouslySetInnerHTML={ getHtml(product.valueDescription) } />
                                            </>
                                        ) }
                                    </div>
                                    { chooseProductFunc && product.introBox?.text && product.type === 'product' && (
                                        <>
                                            <br />
                                            <Button color="white" onClick={ chooseProductFunc }>
                                                { chooseProductTextValue || product.cta || 'Vælg' }
                                            </Button>
                                        </>
                                    ) }

                                </>
                            ) : (
                                <>
                                    <div className="divider"></div>
                                    { product.image && (
                                        <p className="focusTextWhite">
                                            <img className="productImage" src={ product.image } alt={ product.name } />
                                        </p>
                                    ) }
                                    <p className="productInfoTitle hidden">{ product.descriptionTitle }</p>

                                    <div>
                                        <ul>
                                            <div className="moreAnchor">
                                                <a onClick={ () => toggleProductBoxContent(elementId) }>+ Læs mere</a>
                                            </div>
                                            <div className="hidden description" dangerouslySetInnerHTML={ getHtml(product.description) } />
                                        </ul>
                                    </div>
                                    <br className="hidden" />
                                    { chooseProductFunc && (
                                        <>
                                            <br />
                                            <Button color="white" onClick={ chooseProductFunc }>
                                                { chooseProductTextValue || product.cta || 'Vælg' }
                                            </Button>
                                        </>
                                    ) }

                                </>
                            ) }
                        </>
                    </div>
                ) }
            </div>
        </>
    );
};

SelectableProduct.propTypes = {
    product: PropTypes.object.isRequired,
    chooseProductFunc: PropTypes.func,
    chooseProductText: PropTypes.string,
    title: PropTypes.string,
    priority: PropTypes.string,
    elementId: PropTypes.string,
    fixedTop: PropTypes.bool,
    className: PropTypes.string,
    selected: PropTypes.bool,
    priceSuffix: PropTypes.string,
};

export default SelectableProduct;
